import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
    infoCardSection: {
        paddingTop: '20px',
        paddingBottom: '20px',
    },
    infoCardContainer: {
        display: 'grid',
        paddingTop: '10px',
        paddingBottom: '10px',
        gridTemplateColumns: '1fr 1fr',
        maxWidth: '560px',
        '@media only screen and (max-width: 768px)': {
            marginRight: 'auto',
            marginLeft: 'auto',
        },
    },
    infoCardItem: {
        backgroundColor: 'hsla(0,0%,100%,.7)',
        borderRadius: '10px',
        padding: '15px',
        display: 'flex',
        color: '#333',
        alignItems: 'center',
        marginTop: '5px',
        marginBottom: '5px',
        '@media only screen and (max-width: 768px)': {
            padding: '10px',
        },
        '& img': {
            maxHeight: '30px',
            marginRight: '15px',
            '@media only screen and (max-width: 768px)': {
                marginRight: '10px',
            },
            '@media only screen and (max-width: 480px)': {
                marginRight: '8px',
                maxHeight: '25px',
            },
        },
        '& p': {
            marginBottom: '0px',
            fontSize: '16px',
            fontWeight: '600',
            textAlign: 'left',
            lineHeight: '1.4',
            '@media only screen and (max-width: 480px)': {
                fontSize: '12px',
            },
            '@media only screen and (max-width: 380px)': {
                fontSize: '11px',
            },
        },
        '&:nth-child(1)': {
            marginRight: '5px',
        },
        '&:nth-child(2)': {
            marginLeft: '5px',
        },
        '&:nth-child(3)': {
            marginRight: '5px',
        },
        '&:nth-child(4)': {
            marginLeft: '5px',
        },
    },
})

function InfoCards() {

    const classes = useStyles()

    return (
        <div className={classes.infoCardSection}>
            <div className={classes.infoCardContainer}>
                <div className={classes.infoCardItem}>
                    <img src="/pitchbattle/images/icons/idea.svg" alt="" />
                    <p>4 Weeks Virtually</p>
                </div>
                <div className={classes.infoCardItem}>
                    <img src="/pitchbattle/images/icons/payment-card-svgrepo-com.svg" alt="" />
                    <p>₹499! <span style={{textDecoration: "line-through"}}>₹999</span><br />*GST Included</p>
                </div>
                <div className={classes.infoCardItem}>
                    <img src="/pitchbattle/images/icons/check-mark.svg" alt="" />
                    <p>Mon - Wed - Friday</p>
                </div>
                <div className={classes.infoCardItem}>
                    <img src="/pitchbattle/images/icons/clock.svg" alt="" />
                    <p>4 PM - 6 PM </p>
                </div>
            </div>
        </div>
    )
}

export default InfoCards
